import { Image, Modal } from "react-bootstrap"

import department from "../../Assets/images/profile-managment/department.svg"
import userid from "../../Assets/images/profile-managment/userid.svg"
import email from "../../Assets/images/profile-managment/email.png"
import call from "../../Assets/images/profile-managment/call.svg" 
import telephone from "../../Assets/images/profile-managment/telephone.svg" 
import role from "../../Assets/images/profile-managment/role.svg"
import { useEffect, useState } from "react"
import * as Yup from 'yup'; 
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { DonorService } from "../../Services/Donor.Service"
import { Sd } from "@mui/icons-material"
import { formatDate, formatTime } from "../../Utils/Common"
import HealthQuestionnairePopup from "./HealthQuestionnairePopup"
// Validation schema using Yup
const validationSchema = Yup.object({
    acceptGeneralRequirements: Yup.bool()
        .oneOf([true], 'This is required')
        .required('This is required'),
    // acceptJob: Yup.bool()
    //     .oneOf([true], 'Please accept the job confirmation')
    //     .required('Please accept the job confirmation'),
    acceptCompensationDependency : Yup.bool()
            .oneOf([true], 'This is required')
            .required('This is required'),
    filledConcentForm : Yup.bool()
            .oneOf([true], 'This is required')
            .required('This is required'),
    healthQuestionnaire : Yup.bool()
        .oneOf([true], 'This is required')
    
});

function JobDetailsAcceptPopup({ show,showModal, onHide, onConfirm, title = "Job Details:", jobNumber, job, type }) {
    const [initialValues, setInitialValues] = useState({
        id: job?.interval_id,
        jobNumber: jobNumber,
        acceptGeneralRequirements: false,
        // acceptJob: false, 
        acceptCompensationDependency : false,
        filledConcentForm : false,
        healthQuestionnaire: false
    });
    const [showHealthQuestionnaire, setShowHealthQuestionnaire] = useState(false);

    const handleShowHealthQuestionAcceptModal = () => {
    //   onHide();  
      setShowHealthQuestionnaire(true);
    }
    const handleCloseHealthQuestionModal = (type) => { 
        // showModal();
        console.log("type",type);

        if(type==='save'){
            setInitialValues((prev) => ({
                ...prev,
                healthQuestionnaire: true,
            }));
        }
        else{
            setInitialValues((prev) => ({
                ...prev,
                healthQuestionnaire: false,
            }));
        }
        setShowHealthQuestionnaire(false);
    }
        
    const [jobDetails, setJobDetails] = useState();
    useEffect(() => { 
        const params = {
            request_id: jobNumber,
            interval_id: job?.interval_id,
            is_matched: job?.matched_sample,
            ...(job?.matched_sample === "no" && { sample_id: job?.sample_ids })
        };
        
        
        DonorService.getJobsDetails(params)
            .then((response) => { 
            const jobsDetails = response.jobs; 
            setJobDetails(jobsDetails);  
        })
        .catch((error) => {
            console.error("Failed to fetch sample request list", error); 
        });


        setInitialValues({
            id: job?.interval_id,   //interval_id 
            jobNumber: jobNumber,   // request_id
            acceptGeneralRequirements: false,
            // acceptJob: false,
            acceptCompensationDependency : false,
            filledConcentForm : false,
            healthQuestionnaire : false
        });
    }, [jobNumber, job]);
    
    return (

        <>
          <Modal show={show} className={showHealthQuestionnaire ? "d-none" : "d-block"}            
            centered onHide={onHide} dialogclassname="el-deactivate-modal" backdrop="static">
                <Modal.Body>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        onConfirm(values);
                        setSubmitting(false);
                    }}
                >
                    {({ values, setFieldValue, errors, touched, isSubmitting }) => (
                        <Form>
                    <div className="p-3" >
                        <h5 className='mb-4'><b>{title}</b></h5>
                        <DetailItem
                            title="Date"
                           
                            detail= {formatDate(jobDetails?.sample_pickup_date)}
                        />
                        <DetailItem
                            title="Time"
                            detail={formatTime(jobDetails?.time_interval)}
                        />
                        <DetailItem
                            title="Appointment Length"
                            detail={`${jobDetails?.donation_duration} minutes`}
                        />
                        <DetailItem
                            title="Location" 
                            detail={`${jobDetails?.lab_name}${jobDetails?.city ? `, ${jobDetails?.city}` :''}${jobDetails?.state ? `, ${jobDetails?.state}` :''}${jobDetails?.country ? `, ${jobDetails?.country}` :''}` }
                        />
                        {jobDetails?.rq_samples && (
                            <> 
                                <DetailItem
                                    title="Sample Type"
                                    detail={jobDetails?.rq_samples
                                        .map((sample) =>
                                            `${sample.name} ${sample?.sample_volume && sample.sample_volume !== null ? `${sample.sample_volume} mL` : ""}`
                                        )
                                        .join(", ")}
                                />  
                            </>
                        )}

                        <DetailItem
                            title="Total Compensation"
                            detail={`$${jobDetails?.total_sample_cost}`}
                        />
                        <DetailItem
                            title="Notes"

                        />
                        <div className="mb-1">
                            {jobDetails?.rq_samples.map((sample, index) => (
                                sample.instruction ? (
                                    <div key={sample.id || index} className="el-content-detail">
                                        <div className="el-request-detail-profile-title">
                                            <b>{sample.name}</b>:
                                            <span className="el-request-detail-profile-name"> {sample.instruction}</span>
                                        </div>
                                    </div>
                                ) : null
                            ))}
                        </div>    
                        {jobDetails?.description_notes
                            .split(",")
                            .filter(note => note.trim() && !note.trim().endsWith(":")) // Filter out empty or incomplete notes
                            .map((note, index) => (
                                <div
                                    key={index}
                                    dangerouslySetInnerHTML={{ __html: note.trim() }}
                                ></div>
                            ))
                        } 
                    </div>
                    <div className="p-3 " style={{ border: '1px solid red', borderRadius: '5px' }}>

                        <h5 className="mb-3"><b>General Requirements:</b></h5>

                        <div> 
                         <DetailItem
                                // iconSrc={userid}
                                title="Smokers Allowed?"
                                detail={jobDetails?.smoker_allowed == 'yes' ? 'Yes' : 'No' || '-'}
                            />
                            <DetailItem
                                // iconSrc={email}
                                title="Vitamins & Herbal Supplements allowed"
                                detail={jobDetails?.herbal_vitamins == 'yes' ? 'Yes' : 'No' || '-'}
                            /> 
                            <DetailItem
                                // iconSrc={telephone}
                                title="All Medications Allowed?"
                                detail={jobDetails?.medication_allowed == 'yes' ? 'Yes' : 'No' || '-'}
                            />

                            {jobDetails?.medication_allowed == 'no' && (<DetailItem
                                // iconSrc={call}
                                title="Excluded Medications"
                                detail={jobDetails?.medication_reason || '-'}
                            />)}
                            {jobDetails?.herbal_vitamins == 'no' && (
                                <DetailItem
                                    // iconSrc={department}
                                    title="Minimum time since last dose of vitamins/supplements or medications"
                                    // Minimum time since last dose of vitamins/supplements or medications:
                                    detail={jobDetails?.herbal_vitamin_note || '-'}
                                />)}

                            {/* <DetailItem
                                // iconSrc={role}
                                title="Donor Restrictions"
                                detail={jobDetails?.donor_restriction_note || '-'}
                            />  */}
                            <DetailItem
                                // iconSrc={role}
                                title="Donor Inclusions"
                                detail={jobDetails?.donor_inclusions_note || '-'}
                            /> 
                            <DetailItem
                                // iconSrc={role}
                                title="Donor Exclusions"
                                detail={jobDetails?.donor_exclusions_note || '-'}
                            /> 
                        </div>

                        {type!=="viewDetails" && (
                             <>

                            <div className=" mt-3">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="acceptGeneralRequirements"
                                        checked={values.acceptGeneralRequirements}
                                        onChange={() => setFieldValue('acceptGeneralRequirements', !values.acceptGeneralRequirements)}
                                    />
                                    <label
                                        className="form-check-label ms-2 text-danger"
                                        htmlFor="acceptGeneralRequirements"
                                    ><i>
                                        {/* <h6>
                                        I have <strong>CAREFULLY</strong> read the General Requirements and Donor Restrictions before accepting this job.
                                        Failure to adhere to the exclusion criteria will jeopardize the integrity of the experiment for which your sample
                                        may be used, and your status in the donor program may be re-evaluated.</h6> */}
                                        <h6 className="font-size-small">
                                            I acknowledge that I have CAREFULLY read the General Requirements before accepting this donation opportunity and my failure to adhere to the criteria may jeopardize the integrity of the study for which my donation may be used and my status in the donor program may be re-evaluated
                                        </h6>
                                        </i>
                                    </label>
                                </div>
                                <ErrorMessage name="acceptGeneralRequirements" component="div" className="text-danger" />
                            </div>
                            <div className="mt-1">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="acceptCompensationDependency"
                                            checked={values.acceptCompensationDependency}
                                            onChange={() => setFieldValue('acceptCompensationDependency', !values.acceptCompensationDependency)}
                                        />
                                        <label
                                            className="form-check-label ms-2 text-danger"
                                            htmlFor="acceptCompensationDependency"
                                        ><i><h6 className="font-size-small">
                                            I understand that compensation is dependant on completing the sample donation.</h6></i>
                                        </label>
                                    </div>
                                    <ErrorMessage name="acceptCompensationDependency" component="div" className="text-danger" />
                            </div>
                            <div className="mt-1">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="filledConcentForm"
                                            checked={values.filledConcentForm}
                                            onChange={() => setFieldValue('filledConcentForm', !values.filledConcentForm)}
                                        />
                                        <label
                                            className="form-check-label ms-2 text-danger"
                                            htmlFor="filledConcentForm"
                                        ><i><h6 className="font-size-small">
                                            I acknowledge that I have previously signed an Informed Consent Form.</h6></i>
                                        </label>
                                    </div>
                                    <ErrorMessage name="filledConcentForm" component="div" className="text-danger" />
                            </div>
                            <div className="mt-1">
                                    <div className="form-check el-mb-0">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="healthQuestionnaire"
                                            checked={values.healthQuestionnaire}
                                            onChange={
                                                () => {
                                                    setFieldValue('healthQuestionnaire', !values.healthQuestionnaire);
                                                    if(!values.healthQuestionnaire === true){
                                                        handleShowHealthQuestionAcceptModal();
                                                        setInitialValues(values);
                                                    }
                                                }
                                            }
                                        />
                                        <label
                                            className="form-check-label ms-2 text-danger"
                                            htmlFor="healthQuestionnaire"
                                        ><i><h6 className="font-size-small">
                                            To proceed, please click here to review and update your health questionnaire.
                                        </h6></i>
                                        </label>
                                    </div>
                                    <ErrorMessage name="healthQuestionnaire" component="div" className="text-danger" />
                            </div>
                        </>
                        )}


                    </div>
                    {/* {type!=="viewDetails" && (
                    <div className="p-3 mt-1">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="acceptJob"
                                    checked={values.acceptJob}
                                    onChange={() => setFieldValue('acceptJob', !values.acceptJob)}
                                />
                                <label
                                    className="form-check-label ms-2 "
                                    htmlFor="acceptJob"
                                ><h6>
                                    BEFORE agreeing to fill a donation request, please confirm that you do not work in the department as the requestor or a sub-group at the same site</h6>
                                </label>
                            </div>
                            <ErrorMessage name="acceptJob" component="div" className="text-danger" />
                    </div>
                    )} */}
                    {/* {type!=="viewDetails" && (
                       
                    )} */}

                    <div className="d-flex my-3 w-fit-content justify-content-start">
                    {type!=="viewDetails" && (
                        <button type="submit" className="el-main-button"><span>Accept and Add To Calendar</span></button>
                    )}
                        <button type="button" onClick={ ()=>{ 
                            onHide();
                            // setJobDetails();
                        }
                        } className="btn"><span>Close</span></button>
                    </div>
                    </Form>
                    )}
                </Formik>
                </Modal.Body>
            </Modal>
            {
            
            showHealthQuestionnaire && (<>
            <HealthQuestionnairePopup showHealthQuestionnaire={showHealthQuestionnaire} handleCloseHealthQuestionModal = {handleCloseHealthQuestionModal} job={job}/>
            </>)}  
        </>
    )
}

export default JobDetailsAcceptPopup
function DetailItem({ iconSrc, title, detail }) {
    return (
        <div className="el-flex-area mb-1">
              {iconSrc != null && ( <div className="location-icon">
                <Image src={iconSrc} alt="" className="me-3" />
            </div>)}
            <div className="el-content-detail">
                <h6 className="el-request-detail-profile-title">{title}:
                    <span className="el-request-detail-profile-name"> {detail}</span></h6>
            </div>
        </div>
    );
} 